<template>
  <div class="page">
    <Header title="申请列表"></Header>

    <div class="worker-info-box">
      <div v-for="(item,index) of clientApplyList"  class="box-shadow worker-info" :key="index">
        <div class="worker-info-item">
          <!-- <img :src="$getImgUrl()" class="head-portrait"/> -->
          <div class="worker-info-detail">
            <div class="worker-info-detail-name">申请人：{{item.contactPerson}}</div>
            <div class="worker-info-detail-mobile">手机号：{{item.contactMobile}}</div>
            <div class="worker-info-detail-time"><span>申请时间：{{item.createDate | parseTime}}</span></div>
          </div>
          <!-- <div :class="['operation',applyId===item.applyId?'operation-active':'']">...</div> -->
          <div class="operation-btn">
            <div class="operation-btn-reject" @click="showConfirmOverlay('03',item.applyId)">驳回</div>
            <div class="operation-btn-consent" @click="showConfirmOverlay('02',item.applyId)">同意</div>
          </div>
        </div>
        <!-- <transition name="van-fade">
          <div class="operation-btn" v-if="applyId===item.applyId">
            <div class="operation-btn-reject" @click="handleApply('03')">驳回</div>
            <div class="operation-btn-consent" @click="handleApply('02')">同意</div>
          </div>
        </transition> -->
      </div>
    </div>

  <van-overlay :show="confirmOverlay" @click="confirmOverlay = false">
    <div class="wrapper-overlay" @click.stop>
      <div class="content-overlay">
        <div class="overlay-cancel" @click="confirmOverlay = false">x</div>
        <div>
          <div class="content-title">是否确认{{userStatus==='02'?'通过':'驳回'}}申请？</div>
          <div class="overlay-block"></div>
        </div>
        <!-- <div v-if="btnType==='userRole'">
          <div class="content-info">
            <van-icon class="overlay-icon" name="passed" size="40" color="#00545e"/>
            <div>该人员身份为{{userRole==='02'?'负责人':'修理工'}}</div>
          </div>
        </div> -->
        <div class="overlay-btn" @click="handleApply()">确定</div>
      </div>
    </div>
  </van-overlay>

  <van-overlay :show="selectOverlay" @click="selectOverlay = false">
    <div class="wrapper-overlay" @click.stop>
      <div class="content-overlay">
        <div class="overlay-cancel" @click="selectOverlay = false">x</div>
        <div class="content-title">设置人员身份</div>
        <div class="select-type-box box-shadow" >
         <van-radio-group v-model="userRole" class="select-type"  checked-color="#00545e">
            <van-radio name="02" ><span class="color-ccc" :class="{'active': userRole === '02'}">负责人</span></van-radio>
            <div style="margin-left:25px"  :class="{'active': userRole === '02'}">扫码积分、积分记录查看、积分使用、券包兑换权限</div>
            <van-radio name="03"><span class="color-ccc" :class="{'active': userRole === '03'}">修理工</span></van-radio>
            <div style="margin-left:25px"  :class="{'active': userRole === '03'}">扫码积分、仅添加购物车（不可使用积分或券包）</div>
          </van-radio-group>
        </div>
        <div class="overlay-btn" @click="apply()">确定</div>
        <!-- <img src="../dialog-bg.png"></img> -->
      </div>
    </div>
  </van-overlay>

  <van-overlay :show="resultOverlay" @click="resultOverlay = false">
    <div class="wrapper-overlay" @click.stop>
      <div class="content-overlay">
        <div class="overlay-cancel" @click="resultOverlay = false">x</div>
        <div class="content-title">账号添加成功</div>
          <div class="content-info">
            <van-icon class="overlay-icon" name="passed" size="40" color="#00545e"/>
            <div>该人员身份为{{userRole==='02'?'负责人':'修理工'}}</div>
          </div>
        <div class="overlay-btn" @click="handleCloseDialog()">确定</div>
      </div>
    </div>
  </van-overlay>

  </div>
</template>

<script>
import Header from '../../components/header.vue'
import centerApi from '@/api/center'
export default {
  components: { Header },
  data () {
    return {
      approveStatus: '01',
      clientApplyList: [],
      applyId: '',
      confirmOverlay: false,
      resultOverlay: false,
      selectOverlay: false,
      hintOverlay: false,
      userStatus: '',
      userRole: ''
    }
  },
  created () {
    this.queryClientUserApplyList()
  },
  methods: {
    queryClientUserApplyList () {
      let params = {
        approveStatus: this.approveStatus
      }
      centerApi.queryClientUserApplyList(params).then(res => {
        if (res.data.resultCode === '0') {
          this.clientApplyList = res.data.resultData.clientApplyList
        }
      })
    },
    showConfirmOverlay (userStatus, applyId) {
      this.userStatus = userStatus
      this.applyId = applyId
      this.confirmOverlay = true
    },
    handleApply () {
      this.confirmOverlay = false
      if (this.userStatus === '03') {
        this.clientUserApplyVerify()
      } else if (this.userStatus === '02') {
        this.selectOverlay = true
      }
    },
    apply () {
      if (this.userStatus === '02') {
        if (this.userRole === '') {
          this.$toast('请设置人员身份！')
          return
        }
        this.confirmOverlay = false
        this.selectOverlay = true
        this.clientUserApplyVerify()
      }

      // this.resultOverlay = true
      // centerApi.clientUserApplyVerify(data).then(res => {
      //   if (res.data.resultCode === '0') {

      //   }
      // })
    },
    clientUserApplyVerify () {
      let data = {
        approveStatus: this.userStatus,
        applyId: this.applyId,
        userRole: this.userRole
      }
      console.log(data)
      centerApi.clientUserApplyVerify(data).then(res => {
        if (res.data.resultCode === '0') {
          this.$toast('操作成功！')
          this.queryClientUserApplyList()
          if (this.userStatus === '02') {
            this.resultOverlay = true
          }
        }
      })
      this.selectOverlay = false
    },
    handleCloseDialog () {
      this.userRole = ''
      this.resultOverlay = false
    }
  }

}
</script>

<style lang="less" scoped>
.work-info{
  position: relative;
}
.worker-info-box{
  margin: 10px 15px;
  width: calc(100% - 30px);
}
.worker-info-item{
  background-color: #fff;
  border-radius: 5px;
  margin: 20px 0 15px 0;
  height: 85px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  .head-portrait{
    margin: 10px;
    border-radius: 5px;
    vertical-align: middle;
  }
  .worker-info-detail{
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    padding: 5px 10px;
    width: calc(100% - 140px);
  }
  .worker-info-detail-name{
    font-size: 14px;
    color: black;
    font-weight: 600;
  }
  .worker-info-detail-mobile{
    color: black;
    font-size: 14px;
    font-weight: 600;
  }
  .worker-info-detail-time{
    text-align: left;
    font-size: 12px;
    span{
      border-radius: 5px;
      padding: 2px;
      color: #dbd035;
      background-color: rgb(255, 252, 213);
    }
  }
}
.head-portrait{
  width: 60px;
  height: 60px;
}
.operation{
  width: 20px;
  height: 20px;
  vertical-align: middle;
  text-align: center;
  background-color: rgb(245, 245, 245);
  position: absolute;
  right: 12px;
  top: 30px;
  line-height: 13px;
}
.operation-active{
  writing-mode:vertical-lr;
  line-height: 30px;
}
.operation-btn{
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: space-evenly;
  margin-right: 10px;
  div{
    border-radius: 10px;
  }
  .operation-btn-reject{
    width: 50px;
    padding: 6px 10px ;
    color: var(--base-green);
    border: 1px solid var(--base-green);
  }
  .operation-btn-consent{
    width: 52px;
    background-color: var(--base-green);
    color: #fff;
    padding: 7px 11px;
  }
}
.select-type{
  color:#ccc;
   .active{
    color:var(--base-green);
  }
}
.color-ccc{
  color:#ccc;
}
</style>
